import React from "react";
import heroVideo from "../../images/hero-video.mp4";
import Header6 from "../Header/Header6";
import SimpleSlider2 from "../Sliders/Slick-slider2";
import bg_vide from "../../videos/hero-video1.mp4";
import Footer2 from "../Footer/Footer2";
function A4HFIRST() {
  return (
    <>
      <style>{`
        body, html {
    margin: 0;
    padding: 0;
  }

  .full-screen-block {
  position: relative;
  width: 100%;
  height: auto;
  overflow: visible;
}

.bg_video {
  width: 100%;
  height: auto;
  object-fit: contain;
  object-position: center center;
  display: block;
}

  .hero-header {
    text-align: center;
    padding: 40px 20px;
    background: linear-gradient(to right, #ffdb5e 0%, #ffffff 100%);
    color: #e91f1f;
  }

  .hero-header h1{
    margin: 0;
    margin-bottom: 50px;
    font-size: 32px;
    font-weight: 900;
    letter-spacing: 1px;
  }

  .hero-header p{
  max-width: 1300px;
  margin: 25px auto;
  font-size: 18px;
  line-height: 1.9;
  color: #222;
  font-weight: 500;
  text-align: justify;
  padding: 0 40px;
  box-sizing: border-box;
}
.section-divider{
  width:100%;
  max-width:900px;
  margin:32px auto 38px;

  display:flex;
  align-items:center;
  justify-content:center;
  gap:18px;
}

.section-divider::before,
.section-divider::after{
  content:"";
  flex:1;
  height:3px;

  background: linear-gradient(
    to right,
    transparent,
    #1a2a5a,
    #d4af37,
    transparent
  );

  border-radius:10px;

  box-shadow:
    0 2px 6px rgba(0,0,0,0.18);
}

.section-divider span{
  font-size:26px;
  color:#1a2a5a;
  text-shadow:0 2px 6px rgba(0,0,0,0.15);

  animation: dividerGlow 2.5s ease-in-out infinite;
}
  @media (max-width: 768px) {

  .hero-header {
    padding: 30px 15px;
  }

  .hero-header h1{
    font-size: 18px;
    line-height: 1.2;
  }

  .hero-header h4{
    font-size: 14px;
    line-height: 1.25;
  }

  .hero-header p{
    font-size: 13px !important;
    line-height: 1.4;
    padding: 0 10px;
    text-align: left;
  }

  .section-divider span{
    font-size: 16px;
  }
}
      `}</style>


      <div  id="home" className="full-screen-block viewport-video-page"> 
        <video
          autoPlay
          loop
          muted
          playsInline
          disablePictureInPicture
          disableRemotePlayback
          className="bg_video"
          onContextMenu={(e) => e.preventDefault()}
        >
                <source src={bg_vide} type="video/mp4"></source>
        </video> 
        
        <Header6/>
        <SimpleSlider2/>
      </div>

      {/* HEADER BELOW VIDEO */}
      <div className="hero-header">
        <h1>AMERICANS4HINDUS - 501(c)(3) NON PROFIT ORGANIZATION</h1>
        <div className="section-divider">
            <span>✦ ✦ ✦</span>
          </div> 
          <h4>
            <strong>
              Preserving Dharma, Developing Leaders, and Strengthening Communities
            </strong>
          </h4>
        <p>
          Americans4Hindus 501(c)(3) is dedicated to advancing educational, cultural, charitable, and community-focused initiatives that strengthen Hindu values, preserve Dharma, and serve society. Through programs such as Hindu Way of Living, Hindu Rajneeti Academy, Temple Rakshak, charitable services, interfaith engagement, and community partnerships, Americans4Hindus works to educate, inspire, and empower individuals while promoting understanding, service, and leadership rooted in timeless Hindu principles.
        </p>

        <p>
        The foundation of Americans4Hindus 501(c)(3) is the belief that strong communities are built upon strong values. As Hindu Americans continue to grow and contribute to every sector of society, it becomes increasingly important to preserve cultural heritage, develop future leaders, strengthen community institutions, and promote a deeper understanding of Hindu philosophy and traditions. Americans4Hindus exists to ensure that future generations remain connected to their roots while becoming confident contributors to the broader American experience.
        </p>
        <p>
          Through educational programs, leadership training, coalition building, temple preservation initiatives, community service projects, and partnerships with diverse organizations, Americans4Hindus 501(c)(3) creates opportunities for learning, collaboration, and service. By combining Dharma, leadership, education, and compassion, Americans4Hindus seeks to build a stronger, more engaged, and more impactful Hindu American community for generations to come.
        </p>
      </div>
      <Footer2/>
    </>
  );
}

export default A4HFIRST;
